import React, { useState, useEffect } from "react";
import BrandWizard from "./brandSteps/BrandWizard";
import { BRANDS_LINKS } from "../globals/brandsLinks";
import { changeTitle } from "../helpers/changeTitle";
import { BRANDS_TITLES } from "../globals/brandsTitles";

const SecondaryPage = props => {
	const [step, changeStep] = useState(0);
	const [page, changePage] = useState(0);

	const imgStyle = {
		width: "11rem",
		height: "3.5rem"
	};

	useEffect(() => {
		let pathnames = window.location.pathname
			.split("/")
			.filter(pathname => pathname !== "");
		if (pathnames.length === 0) {
			return;
		}
		let last = pathnames[pathnames.length - 1];

		let value = BRANDS_LINKS.findIndex(
			brand => last.toLowerCase() === brand
		);
		if (window.analogRedirected !== true && value !== -1) {
			window.analogRedirected = true;
			nextStep(value);
			changeTitle(BRANDS_TITLES[value]);
		}
	});

	function nextStep(index) {
		changeStep(index);
		changePage(1);
		if (page === 0) {
			props.changeActive(false);
		}
	}

	const images = [
		{
			style: {
				backgroundColor: "rgb(253,211,73)"
			},
			childStyle: imgStyle
		},
		{
			style: {
				backgroundColor: "rgb(0,17,229)"
			},
			childStyle: imgStyle
		},
		{
			style: { backgroundColor: "rgb(239,111,47)" },
			childStyle: imgStyle
		},
		{
			style: { backgroundColor: "rgb(70,90,100)" },
			childStyle: imgStyle
		},
		{
			style: { backgroundColor: "rgb(61,207,135)" },
			childStyle: imgStyle
		},
		{
			style: { backgroundColor: "rgb(197,55,69)" },
			childStyle: imgStyle
		},
		{
			style: { backgroundColor: "rgb(253,92,100)" },
			childStyle: imgStyle
		},
		{
			style: { backgroundColor: "rgb(251,77,109)" },
			childStyle: imgStyle
		}
	];

	const contentStyle = {
		...props.contentStyle,
		paddingBottom: "0"
	};
	if (page === 0) {
		return (
			<div className="wrapperStyle" id="secPage">
				<div style={contentStyle}>
					<img
						className="pictureLogo"
						alt="pictureLogo"
						src={"/skaiciuokle/img/face.png"}
					/>
					<div className="mainTitle secondaryPageMainTitle">
						Norite populiaraus projekto analogo?
					</div>
					<div className="secondaryTitle secondaryPageSecondaryTitle">
						Sužinokite kiek tai gali kainuoti
					</div>
					<div className="parentStyle otherBrandsContainer">
						{images.map((value, index) => {
							let newStyle = value.style;
							return (
								<div
									className="logoStyle"
									onClick={() => {
										nextStep(index);
										changeTitle(BRANDS_TITLES[index]);
										window.history.pushState(
											{},
											"",
											`/${BRANDS_LINKS[index]}`
										);
									}}
									key={index}
									style={newStyle}
								>
									<img
										alt="brandLogo"
										style={value.childStyle}
										src={`/skaiciuokle/img/logo0${index +
											1}.png`}
									/>
								</div>
							);
						})}
					</div>
				</div>
			</div>
		);
	} else if (page === 1) {
		return (
			<div className="wrapperStyle">
				<BrandWizard
					contentStyle={props.contentStyle}
					changePage={changePage}
					changeActive={props.changeActive}
					mainTitle={props.mainTitle}
					step={step}
				/>
			</div>
		);
	}
};

export default SecondaryPage;
